import { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { getUser } from '../utils/api';

const ProtectedRoute = ({ children }) => {
  const [authStatus, setAuthStatus] = useState({
    isAuthenticated: null,
    hasSubscription: null,
    isAdmin: false,
    loading: true
  });

  useEffect(() => {
    const checkAuthAndSubscription = async () => {
      try {
        const user = await getUser();
        console.log('ProtectedRoute: User check result:', user);

        if (!user) {
          setAuthStatus({
            isAuthenticated: false,
            hasSubscription: false,
            isAdmin: false,
            loading: false
          });
          return;
        }

        // Check if user is admin (admins always have access)
        const isAdmin = user.role === 'admin';

        // Check subscription status from user object
        const hasSubscription = user.isSubscribed || isAdmin;

        setAuthStatus({
          isAuthenticated: true,
          hasSubscription,
          isAdmin,
          loading: false
        });

        // Show warning for users without subscription (but allow access for now)
        if (!hasSubscription && !isAdmin) {
          console.log('ProtectedRoute: User has no active subscription');
          // We allow access but could show a banner or redirect based on requirements
        }

      } catch (error) {
        console.error('ProtectedRoute: Auth check failed:', error);
        setAuthStatus({
          isAuthenticated: false,
          hasSubscription: false,
          isAdmin: false,
          loading: false
        });
      }
    };

    checkAuthAndSubscription();
  }, []);

  if (authStatus.loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-lg text-gray-600">Loading...</div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!authStatus.isAuthenticated) {
    return <Navigate to="/admin/login" replace />;
  }

  // Allow access for authenticated users (subscription check handled by individual components)
  // This gives more granular control - components can check specific features
  return children;
};

export default ProtectedRoute;
